"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _auction_status = _interopRequireDefault(require("@/components/customPage/auction_status.vue"));
var _system = require("@/api/system");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    auctionStatus: _auction_status.default
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  data: function data() {
    return {
      defaultData: [{
        image: 'https://artimg2.artart.cn/image/20211022/447940859f11823f4adf5b7fe249b648.png',
        name: '新疆天然和田玉青玉无暇好玉在新疆特大优惠专新疆天然和田玉青玉无暇好玉在新疆特大优惠专',
        tags: ['包邮', '包退'],
        price: '￥5,200',
        sign: '235次出价'
      }, {
        image: 'https://artimg2.artart.cn/image/20211023/7c0028ed94e3f35e7859cac94884f6ed.png',
        name: '新疆天然和田玉青玉无暇好玉在新疆特大优惠专新疆天然和田玉青玉无暇好玉在新疆特大优惠专',
        tags: ['包邮', '包退'],
        price: '￥5,200',
        sign: '235次出价'
      }, {
        image: 'https://artimg2.artart.cn/image/20211023/7c0028ed94e3f35e7859cac94884f6ed.png',
        name: '新疆天然和田玉青玉无暇好玉在新疆特大优惠专新疆天然和田玉青玉无暇好玉在新疆特大优惠专',
        tags: ['包邮', '包退'],
        price: '￥5,200',
        sign: '235次出价'
      }, {
        image: 'https://artimg2.artart.cn/image/20211022/447940859f11823f4adf5b7fe249b648.png',
        name: '新疆天然和田玉青玉无暇好玉在新疆特大优惠专新疆天然和田玉青玉无暇好玉在新疆特大优惠专',
        tags: ['包邮', '包退'],
        price: '￥5,200',
        sign: '235次出价'
      }],
      tag: ''
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    viewData: function viewData() {
      if (this.content.type === 2 && this.content.data && this.content.data.length > 0) {
        return this.content.data;
      } else {
        return this.defaultData;
      }
    },
    isComponent: function isComponent() {
      return this.$route.name === 'basicsDiy';
    },
    listTwoImgStyle: function listTwoImgStyle() {
      var marginWidth = this.facade.left_margin * 3;
      var pageMargin = this.facade.page_margin * 2;
      if (this.facade.img_style === 1) {
        return {
          width: (750 - marginWidth - pageMargin) / 4 + 'px',
          height: 'auto'
        };
      } else {
        return {
          width: (750 - marginWidth - pageMargin) / 4 + 'px',
          height: (750 - marginWidth - pageMargin) / 4 + 'px'
        };
      }
    },
    listThreeWidth: function listThreeWidth() {
      var marginWidth = this.facade.left_margin * 4;
      var pageMargin = this.facade.page_margin * 2;
      return parseInt((750 - marginWidth - pageMargin) / 6, 10) + 'px';
    }
  },
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面渲染前
   * @return {[type]} [description]
   */
  created: function created() {
    var _this = this;
    (0, _system.getConfigClassKeys)('home_page_data').then(function (res) {
      var data = res.data;
      if (data.tag_style) {
        _this.tag = JSON.parse(data.tag_style);
      }
    }).catch(function () {});
  },
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {}
};
exports.default = _default;